<template>
    <div class="careers__section">

        <div class="head__text__col" v-bind:style="{ backgroundImage: image_url('left') }">
            <p class="red">WANT TO</p>
            <p class="white">JOIN US</p>
        </div>

        <div class="careers__content">
           
            <div class="join">

                <div class="mobile__intro">
                    <p class="red">JOIN</p>
                    <p class="white">US</p>
                </div>

                <div class="items">

                    <p class="subline" id="subline_text">positions</p>
                    <p class="headline">CAREERS</p>

                    <div class="careers__row">
                        <div class="description">
                            <p>
                                Welcome to Gate21! We provide services related to character design, rigging, and pipeline solutions and we're seeking exceptional innovators to join us.
                                As a proud member of the THQ Nordic company within the Embracer group, our supportive work environment offers competitive salaries and unparalleled growth opportunities for ambitious individuals.
                                We're expanding our team and establishing new standards to cater better to our clients' needs. If you have experience in 3D modeling, texturing, rigging, or programming, apply today.
                                We believe that the best work happens when we collaborate, inspire each other, and push the boundaries of what's possible. Our team is passionate about what we do, and we're committed to creating an environment where everyone can thrive.
                            </p> 
                        </div>

                        <p class="mobile-lookinfor">WE ARE LOOKING FOR</p>
                        
                        <open-positions :careers="this.careers"></open-positions>

                    </div>

                    <div class="join__action__text">
                        <p class="bold-text">
                            FOUND SOMETHING THAT 
                            SUITS YOU BEST?
                        </p>

                        <p class="regular-text">
                            Let's make great things happen together!
                        </p>

                        <a href="/careers" class="mobile__joinus"><p>JOIN US NOW</p></a>

                    </div>
                    

                    <a class="join__anim_button" @mouseenter="slideUp()" @mouseleave="slideDown()" href="/careers">
                        <p>JOIN US NOW</p>
                    </a>
                </div>
                <div class="span_bg" id="slide_up_bg"></div>
            </div>
        </div>

        <div class="right__img" v-bind:style="{ backgroundImage: image_url('right') }"></div>

    </div>
</template>
<script>
    export default {
        data(){
            return {
            }
        },
        props: ['careers', 'left_image', 'right_image'],
        methods: {
            slideUp(){
                const bg = document.getElementById('slide_up_bg');
                const textSubline = document.getElementById('subline_text');
                if(!bg.classList.contains('visible')) {
                    bg.classList.add('visible');
                    textSubline.classList.add('white');
                }
            },

            slideDown(){
                const bg = document.getElementById('slide_up_bg');
                const textSubline = document.getElementById('subline_text');
                if(bg.classList.contains('visible')){
                    bg.classList.remove('visible');
                    textSubline.classList.remove('white');
                }
            },

            image_url(position){
                if(position === 'left') return "url('" + this.left_image.media_URL + "')"
                if(position === 'right') return "url('" + this.right_image.media_URL + "')"
            }
        }
    }
</script>
<style lang="scss" scoped>

    .careers__section{
        // background: #5C2D90;
        background: linear-gradient(180deg, #2A1542 0%, #000000 100%);
        // height: calc(100% - 64px);
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: row;
        
        .head__text__col{
            width: 100%;
            min-width: 640px;
            height: 100%;

            display: flex;
            flex-direction: column;
            justify-content: flex-end;

            // background: url('/images/careers/left.webp') no-repeat;
            // background-position: 0 0;
            background-position: 60% 0;
            background-repeat: no-repeat;
            position: relative;

            &:after{
                content: ' ';
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
                background-color: rgba(0,0,0,.5);
                z-index: 1;

                border-right: 1px solid #ED1163; 
            }


            .red{
                font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                font-style: normal;
                font-weight: 700;
                font-size: 50px;
                line-height: 50px;

                margin:0;
                margin-left: 92px;
                margin-right: 86px;

                color: #ED1163;
                z-index: 2;
            }

            .white{
                font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                font-style: normal;
                font-weight: 500;
                font-size: 150px;
                line-height: 150px;
                
                margin:0;
                margin-left: 92px;
                margin-right: 8px;
                margin-bottom: 64px;

                color: #FFFFFF;
                z-index: 2;
            }
        }

        .careers__content{
            width: 100%;
            min-width: 1111px;
            max-width: 1111px;
            // height: 100%;
            height: auto;

            .join{
                display: block;
                width: 100%;
                height: 100%;
                position: relative;
                box-shadow: 0px -4px 4px rgba(0, 0, 0, 0.25);
                background: linear-gradient(180deg, #2A1542 0%, #000000 100%);

                position: relative;
                user-select: none;

                .mobile__intro{
                    display: none;
                    flex-direction: column;
                    width: calc(100% - 22px);
                    margin-left: 11px;
                    margin-right: 11px;
                    border-bottom: 1px solid #ED1163;
                    margin-bottom: 10px;
                    padding-top: 6px;

                    .red{
                        font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 14px;
                        line-height: 17px;
                        /* identical to box height */
                        text-align: end;

                        color: #ED1163;
                        margin: 0;
                        margin-right: 11px;
                    }

                    .white{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 16px;
                        line-height: 19px;
                        text-align: end;

                        color: #FFFFFF;
                        margin: 0;
                        margin-right: 11px;
                    }
                }
                
                .items{
                    display: flex;
                    flex-direction: column;
                    // height: 100%; - bug overflow
                    height: calc(100% - 92px);
                    position: relative;
                    z-index: 1;
                    padding-top: 92px;

                    .subline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 20px;
                        line-height: 24px;
                        /* or 120% */

                        margin-left: 84px;
                        margin-bottom: 0;
                        color: #ED1163;
                        // margin-top: 30px;
                        margin-top: 53px;

                        transition: all .3s ease;
                        

                        &.white{
                            color: #fff;
                        }
                    }

                    .headline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 50px;
                        line-height: 60px;
                        
                        color: #FFFFFF;
                        margin: 0;
                        // margin-left: 84px;
                        margin-left: 82px;
                    }

                    .careers__row{
                        display: flex;
                        flex-direction: row;

                        margin-left: 84px;
                        margin-right: 42px;

                        margin-top: 40px;

                        .description{
                            display: block;
                            width: 312px;
                            height: 363px;
                            // border: 2px solid;
                            // border-image-slice: 1;
                            // border-width: 2px;
                            // border-image-source: linear-gradient(to left, #5C2C90, #ED1163);
                            margin-right: 80px;

                            p{
                                font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                // font-weight: 300;
                                font-size: 16px;
                                line-height: 17px;
                                /* or 17px */

                                text-align: left;

                                color: #FFFFFF;
                                // padding: 30px;

                                margin: 0;
                            }
                        }

                        .mobile-lookinfor{
                            display: none;
                            font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 700;
                            font-size: 14px;
                            line-height: 17px;
                            /* identical to box height */

                            text-transform: uppercase;

                            color: #ED1163;
                            margin: 0;
                            margin-bottom: 20px;
                        }
                    }

                    .join__action__text{
                        display: flex;
                        flex-direction: column;

                        .bold-text{
                            font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            // font-weight: 700;
                            font-size: 20px;
                            line-height: 24px;

                            color: #FFFFFF;
                            width: 230px;

                            margin-left: 84px;
                            margin-top: 60px;
                        }

                        .regular-text{
                            font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                            font-style: normal;
                            font-weight: 300;
                            font-size: 18px;
                            line-height: 22px;

                            color: #FFFFFF;

                            margin-left: 84px;
                            width: 100%;
                            max-width: 617px;
                        }

                        .mobile__joinus{
                            display: none;
                            background: rgba(0, 0, 0, 0.6);
                            border: 1px solid #ED1163;

                            width: 100%;
                            margin-left: auto;
                            margin-right: auto;
                            margin-bottom: 40px;
                            height: 31px;

                            p{
                                font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                // font-weight: 700;
                                font-size: 12px;
                                line-height: 33px;
                                text-align: center;

                                color: #FFFFFF;
                                margin: 0;
                            }
                        }
                    }

                   

                    .join__anim_button{
                        display: block;
                        // height: 150px;
                        width: 392px;

                        margin-bottom: 23px;
                        
                        margin-left: auto;
                        margin-right: auto;
                        cursor: pointer;

                        text-decoration: none;

                        p{
                            font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                            font-size: 30px;
                            line-height: 30px;
                            /* or 30px */
                            text-align: center;

                            margin-top: 8px;

                            color: #FFFFFF;
                        }

                    }
                }

                .span_bg{
                    background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                    height: 0;
                    width: 100%;
                    transition: all .3s ease-in-out;
                    margin-top: auto;
                    margin-bottom: 0;
                    opacity: 0;
                    position: absolute;
                    bottom: 0;
                    left: 0;

                    &.visible{
                        height: calc(100%);
                        bottom: 0;
                        opacity: 1;
                    }
                    // z-index: ;
                }
            }
        }

        .right__img{
            min-width: 168px;
            height: 100%;

            // background: url('/images/careers/right.webp') no-repeat;
            background-position: top;
            background-repeat: no-repeat;
            position: relative;

            margin-left: auto;
            margin-right: 0;
            border-left: 1px solid #ED1163;
        }
    }

    @media screen and (max-width: 1750px) {
        .careers__section{

            .head__text__col{
                width: 100%;
                min-width: 168px;

                .red, .white{
                    display: none;
                }
            }

        }
    }

    @media screen and (max-width: 1450px) {
        .careers__section{
            
            .head__text__col{
                min-width: initial;
            }

            .right__img{
                width: 100%;
                min-width: initial;
            }

        }
    }

    @media screen and (max-width: 836px) {
        .careers__section{
            background: #000;
            flex-direction: column;

            .head__text__col{
                display: none;
            }

            .careers__content{
                overflow: initial;
                min-width: 100%;
                max-width: 100%;

                .join{

                    .mobile__intro{
                        display: flex;
                    }

                    .items{
                        padding-top: 0;
                        height: 100%;

                        .subline,.headline{
                            margin-left: 0;
                            padding: 0 21px;
                        }

                        .subline{
                            font-size: 12px;
                            line-height: 14px;

                            color: #FFFFFF;
                            margin-top: 0;
                        }

                        .headline{
                            font-size: 25px;
                            line-height: 30px;
                            margin-bottom: 10px;

                            color: #FFFFFF;
                        }

                        .careers__row{
                            flex-direction: column;
                            margin-left: 0;
                            margin-right: 0;

                            margin-top: 0;
                            padding: 0 21px;

                            .description{
                                border: none;
                                width: 100%;
                                height: auto;
                                margin-bottom: 42px;

                                p{
                                    padding: 0;
                                }
                            }

                            .mobile-lookinfor{
                                display: block;
                            }


                        }

                        .regular-text{
                            max-width: 100%;
                        }

                        .join__action__text{
                            background: linear-gradient(90deg, rgba(237, 17, 99, 0.75) 0%, rgba(92, 44, 144, 0.75) 100%);
                            padding: 0 21px;
                            margin-top: 50px;

                            .mobile__joinus{
                                display: block;
                            }

                            .bold-text, .regular-text{
                                margin-left: 0;
                            }

                            .bold-text{
                                font-size: 22px;
                                line-height: 26px;
                                text-align: center;
                                margin-left: auto;
                                margin-right: auto;
                                width: 250px;
                                margin-top: 40px;
                            }

                            .regular-text{
                                font-size: 14px;
                                line-height: 14px;
                                text-align: center;
                                margin-bottom: 24px;
                            }
                        }

                        .join__anim_button{
                            display: none;
                        }
                    }
                }
                   
            }

            .right__img{
                display: none;
            }

        }
    }

    @media screen and (min-width: 836px) and (max-height: 900px) {
        .careers__section{

            .careers__content{

                .join{

                    .items{
                        
                        .careers__row{
                            margin-top: 4px;
                        }

                        .join__action__text{
                            flex-direction: row;

                            .bold-text, .regular-text{
                                margin-top: 20px;
                            }
                        }

                        .join__anim_button{
                            margin-top: 0;
                            margin-bottom: auto;

                            p{
                                margin-top: 0;
                            }
                        }
                    }

                }

            }

        }
    }

</style>